import api from '~/api';
import { UserResponse, UserStatusResponse } from '../dtos/usersResponse';
import { User, UserStatus } from '../models/users.model';

const StatusMap: Record<UserStatusResponse, UserStatus> = {
  active: 'Active',
  inactive: 'Inactive',
};

export async function getParnerUsers(partnerId: string): Promise<User[]> {
  const { data } = await api.get<UserResponse[]>(`v1/partner/${partnerId}/partner_users`);
  return data.map(
    (user) =>
      new User(
        user.id,
        user.first_name,
        user.last_name,
        user.email,
        user.phone_number,
        StatusMap[user.status]
      )
  );
}
